import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { UserCheck } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { FlowNode, NodeVisualDefinition } from '../../types';

import { ApprovalConfigType, getApprovalPreviewText } from './schema';

/** Typed node for approval */
type ApprovalNodeType = FlowNode<ApprovalConfigType>;

/** Visual definition for the Approval node */
export const approvalVisualDefinition: NodeVisualDefinition = {
  key: 'Approval',
  label: 'Approval',
  description: 'Require approval before continuing the flow',
  icon: UserCheck,
  color: 'purple',
  handles: [
    {
      type: 'target',
      position: Position.Top,
      className: 'bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      id: 'approved',
      className: 'left-[25%]! bg-gray!',
    },
    {
      type: 'source',
      position: Position.Bottom,
      id: 'rejected',
      className: 'left-[75%]! bg-gray!',
    },
  ],
  getContent: getApprovalPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Approval nodes on the canvas.
 * Uses BaseNode with dual source handles for approved/rejected branches.
 */
export const ApprovalNode = React.memo<NodeProps<ApprovalNodeType>>((props) => (
  <BaseNode
    {...props}
    definition={approvalVisualDefinition}
    className="@ApprovalNode"
  />
));

ApprovalNode.displayName = 'ApprovalNode';
